import angular from 'angular';
import moment from 'moment';
import * as R from 'ramda';

export default function EditPackageSummaryDialogController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  loaderService,
  alerts,
  docDataService,
  reportsDataService,
) {
  const vm = this;

  vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.monthlyDayOfMonth = vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.monthlyDayOfMonth || 1;
    
  vm.minDate = new moment();
  vm.timeIsValid = true;

  vm.canExpand = vm.status !== 'No Folder Added';
  vm.itemsLoaded = false;

  vm.handleGeneratePackage = handleGeneratePackage;
  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSavePackageSummary = _handleSavePackageSummary;
  vm.handleScheduleTimeChange = _handleScheduleTimeChange;

  _activate();

  // //////// METHODS //////////

  function _activate() {

    if (moment(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.rangeStartDate).format('MM/DD/YYYY') === "01/01/1900") {
      vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.rangeStartDate = new moment().format('MM/DD/YYYY');
    }

    if (vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.scheduleType === 1) { // Once
      vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.onceExecutionDate = moment(vm.schedule.scheduleParameters.scheduleParametersObject.executionDate)
        .format('MM/DD/YYYY');
      vm.minDate = moment(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.onceExecutionDate).format('MM/DD/YYYY');
    } else if (vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.scheduleType === 2) { // Weekly
      vm.minDate = moment(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.rangeStartDate).format('MM/DD/YYYY');
    }

    if (!R.isNil(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionDate)) {
      vm.executionDate = moment(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionDate);
    }

    vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionHour = vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.hour;
    vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionMinute = vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.minute;
    vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionAMPM = vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.ampm;
      
    if (vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionAMPM === '1') {
      vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionHour -= 12;
    }
    
    vm.itemsLoaded = true;

    return;
  }

  function _handleSavePackageSummary() {
    if (_isValid()) {
      vm.reportPackage.reportPackageConfiguration.reportPackageSchedule = _getScheduleParametersFromUI(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject);
      vm.reportPackage.reportPackageConfiguration.scheduleParametersObject = null;
      
      reportsDataService.saveReportPackage(vm.reportPackage.reportPackageConfiguration).then(response => {
        const savedReportPackage = response.data;
        if (savedReportPackage.reportPackageId === 'undefined' || savedReportPackage.reportPackageId <= 0) {
          // There was an error saving the Report Package information
          alerts.error('Error occurred while saving the Report Package Name.');
        } else {
          // The reportPackage information has been saved
          vm.reportPackage.reportPackageConfiguration = savedReportPackage;
          alerts.success('The Report Package Name has been saved successfully.');
          $rootScope.$broadcast('refreshReportPackages');
          _handleCloseDialog();
        }
      });
    }
  }

  function _handleScheduleTimeChange() {
    _timeIsValid();
  }

  function _isValid() {
    let isValid = $scope.prEditPackageSummaryForm.$valid;

    if (!isValid) {
      isValid = true;
      angular.forEach($scope.prEditReportPackageForm.$error.parse, () => {
        isValid = false;
      });
      angular.forEach($scope.prEditReportPackageForm.$error.pattern, () => {
        isValid = false;
      });
      angular.forEach($scope.prEditReportPackageForm.$error.required, () => {
        isValid = false;
      });
    }
    return isValid;
  }

  function handleGeneratePackage() {
    return reportsDataService.createPackageFileGenerationRequest(vm.reportPackage.reportPackageId).then(() => {
      alerts.success(
        'The Report Package has been successfully requested. ' +
          'You will receive an email notification when the file generation is complete.',
      );
    });
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.editReportPackageDialog);
  }
  
  function _timeIsValid() {
    let isValid = true;
    const date = '12/23/1973 ';
    const generationStartTime = vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.blackoutUntil === null ? '00:00:00' : vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.blackoutUntil;
    let hour = 11;
    let minute = 59;

    if (!R.isNil(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionHour)) {
      hour = vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionHour;
    }

    if (!R.isNil(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionMinute)) {
      minute = vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionMinute;
    }

    if (!R.isNil(vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionAMPM)) {
      if (vm.reportPackage.reportPackageConfiguration.scheduleParametersObject.executionAMPM === '1') {
        hour += 12;
      }
    }

    const earliestExecutionTime = moment(date + generationStartTime);
    const execTime = `${date + hour}:${minute}:00`;
    const currentExecutionTime = moment(execTime);

    if (currentExecutionTime < earliestExecutionTime) {
      isValid = false;
    }
    vm.timeIsValid = isValid;
    return isValid;
  }
  
  function _getScheduleParametersFromUI(scheduleObj) {
    
    const scheduleParameters = {
      scheduleType: scheduleObj.scheduleType,
    };

    // Execution Time
    scheduleParameters.hour = scheduleObj.executionHour;
    scheduleParameters.minute = scheduleObj.executionMinute;
    scheduleParameters.ampm = scheduleObj.executionAMPM;

    // Recurrence Pattern
    if (scheduleObj.scheduleType === 1) { // Once
      scheduleParameters.executionDate = moment(scheduleObj.onceExecutionDate).format('MM/DD/YYYY');
      vm.schedule.schedule.rangeEndDate = moment(scheduleParameters.executionDate).add(1, 'd').format('MM/DD/YYYY');
    } else if (scheduleObj.scheduleType === 2) { // Weekly
      scheduleParameters.weeklySunday = scheduleObj.weeklySunday || false;
      scheduleParameters.weeklyMonday = scheduleObj.weeklyMonday || false;
      scheduleParameters.weeklyTuesday = scheduleObj.weeklyTuesday || false;
      scheduleParameters.weeklyWednesday = scheduleObj.weeklyWednesday || false;
      scheduleParameters.weeklyThursday = scheduleObj.weeklyThursday || false;
      scheduleParameters.weeklyFriday = scheduleObj.weeklyFriday || false;
      scheduleParameters.weeklySaturday = scheduleObj.weeklySaturday || false;
    } else if (scheduleObj.scheduleType === 3) { // Monthly
      scheduleParameters.monthlyDayOfMonth = scheduleObj.monthlyDayOfMonth;
    }

    // Recurrence Range
    scheduleParameters.rangeStartDate = moment(scheduleObj.rangeStartDate).format('MM/DD/YYYY');

    if (R.isNil(scheduleObj.rangeEndDate)) { // No End Date
      scheduleParameters.rangeEndDate = null;
      scheduleParameters.recurranceType = 1;
    } else { // Has End Date
      scheduleParameters.rangeEndDate = moment(scheduleObj.rangeEndDate).format('MM/DD/YYYY');
      scheduleParameters.recurranceType = 2;
    }

    return scheduleParameters;
  }
}

EditPackageSummaryDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'alerts',
  'docDataService',
  'reportsDataService',
];
